
import { store } from "../store";
import appConfig from "../../config/app_config";
import TagsObject from "../objects/TagsObject.js";
import * as dssRequest from "../api/dssRequest.js";
import BaseObject from "./BaseObject";

/**
 * Main object to manage user login and set the relevant flags
 * in the store
 */
export default class UserObject {
  constructor(uniqueId, email, userType, password = "", goToAfterRegistration = "") {
    if(!_.isEmpty(uniqueId)){
      this.uniqueId = uniqueId.trim();
    }
    this.email = email.trim();
    this.password = password.trim();
    this.tags = [];
    this.userData = null;
    this.userType = userType.trim();
    this.goToAfterRegistration = goToAfterRegistration.trim();
  }

  userRegister(cs = null, ce = null) {
    const payload = UserObject._createRegisterRequestObject({
      email: this.email,
      password: this.password,
      type: this.userType,
      goTo: this.goToAfterRegistration,
    });
    dssRequest.doRequest(
      response => {
        console.log("register user response", response);
        this.uniqueId = response.data.UserID;
        this.loading = false;
        this.loginSuccess = true;
        store.commit("auth/setUserName", this.uniqueId);
        // store.commit("auth/setToken", response.data.access_token);
        if (cs !== null) cs(response);
      },
      error => {
        if (ce !== null) ce(error);
      },
      "registerUser",
      store.getters.getCurrentAccountId,
      payload
    );
  }

  /**
   * the function takes case to store the uniqueId passed, request the getUserData and store
   * the returned values.
   * @param {callback success} cs if passed, it will be called when the login is successful
   * @param {callback error} ce if passed, it will be called when the login fails
   */
  userlogin(cs = null, ce = null) {
    let account = {
      Email : this.email,
      Password : this.password
    };
    const payload = {
      Email: this.email,
      Password: this.password,
      client_id: appConfig.Userlogin.clientId,
      client_secret: appConfig.Userlogin.clientSecret,
      grant_type: "personal_token",
      scope: "*"
    };
    store.commit('auth/setToken', '');
    dssRequest.doRequest(
      (response) => {
        console.log('The call for login was successful', this.userType, response);
        this.loading = false;
        this.loginSuccess = true;
        store.commit('setRememberAccountPassword', account);
        store.commit('auth/setUserType', this.userType);
        store.commit('auth/setUserName', response.data.UserId);
        store.commit('auth/setToken', response.data.AccessToken);
        store.commit('auth/setUserLevel', response.data.UserLevel);
        // this.checkUserTags(this.password);
        console.log('check t ', response.data);
        if (response.data.UserLevel === 6 && response.data.PartnerId !== -1) {
          store.commit('auth/setPartnerId', response.data.PartnerId);
        } else {
          store.commit('auth/setPartnerId', -1);
        }
        if (response.data.PartnerId !== -1 && !!!this.getSavePartnerId ) {
          console.log(" response datat PARTNER DINGEN", response.data.PartnerId, this.getSavePartnerId)
          store.commit("setSavePartnerId", response.data.PartnerId);
        }
        this.getUserData(cs, ce);
      },
      (error) => {
        console.log("The call for login was not successful", error);
        if (ce !== null && typeof ce === "function") ce(error);
        // window.EventBus.fire("triggerGenericErrorDialog", 'Error, wrong data');
      },
      "login",
      appConfig.dss.accountManagerObjectId,
      payload,
      600000,
      false
    );
  }
  checkUserTags(user) {
    let payload = {
      UserId: user,
      FunctionId: "TagsFunctionLibrary::getUserTags"
    };
    dssRequest.doRequest(
      response => {
            console.log(
              "The generic call getUserTags was successful",
              response
            );

            let receivedTags = [];
            for (let [key, value] of Object.entries(response.data)) {
              if (key === user) {
                receivedTags = BaseObject._createArrayWithObjects(value);
              }
            }
            store.commit("setUSerIsCrowdScout", false);
            receivedTags.forEach( e => {
              // Check if user is CrowdScout and belongs to current account
              if (e.Description === 'Crowd Scout' && e.AccountId === store.getters.getCurrentAccountId) {
                store.commit("setUserIsCrowdScout", true);
              }
            });
      },
    error => {
            console.log(
              "The generic call getUserTags was not successful",
              error
            );
      },
      "communicateWithDBLibrary",
        store.getters.getCurrentAccountId,
        payload
    );
  }
  getUserData(cs, ce) {

    dssRequest.doRequest(
      response => {
        console.log("The call for getUserData was successful", response);
        // store.commit("auth/setUserLevel", 1);
        this.parseUserData(response.data);
        if (cs !== null && typeof cs === "function") cs(response);
      },
      error => {
        console.log("The call for getUserData was not successful", error);
        if (ce !== null && typeof ce === "function") ce(error);
      },
      "getUserData",
      store.getters.getCurrentAccountId,
      this.createGetUserDataRequest()
    );
  }

  static getUserDataStatic(cs, ce) {

    dssRequest.doRequest(
      response => {
        console.log("The call for getUserData was successful", response);
        // store.commit("auth/setUserLevel", 1);
        this.userData = BaseObject._toLowerCaseInitialProperty(BaseObject._createArrayWithObjects(response.data.UserData.User));
        console.log("tags and userdata", this.tags, this.userData);
        // this.checkUserTags();

        store.commit("auth/setUser", {
          userData: this.userData[0]
        });

        if (response.data.UserData.UserLanguage.LanguageTagId !== undefined) {
          store.commit("setUserLanguage", response.data.UserData.UserLanguage.LanguageTagId)
        }
        if (cs !== null && typeof cs === "function") cs(response);
      },
      error => {
        console.log("The call for getUserData was not successful", error);
        if (ce !== null && typeof ce === "function") ce(error);
      },
      "getUserData",
      store.getters.getCurrentAccountId,
      {
        RelationType: "User",
        Id: store.getters["auth/userName"],
        Types: {
          "User":"User",
        },
      },
    );
  }
  static parseUserDataStatic(data) {
    this.userData = BaseObject._toLowerCaseInitialProperty(BaseObject._createArrayWithObjects(data.UserData.User));
    console.log("tags and userdata", this.tags, this.userData);
    // this.checkUserTags();

    store.commit("auth/setUser", {
      userData: this.userData[0]
    });

    if (data.UserData.UserLanguage.LanguageTagId !== undefined) {
      store.commit("setUserLanguage", data.UserData.UserLanguage.LanguageTagId)
    }
  }
  parseUserData(data) {

    // if (data.Matrix !== undefined && data.Matrix.TrialTags !== undefined) {
    //   Object.defineProperty(data.Matrix, "Tags",
    //     Object.getOwnPropertyDescriptor(data.Matrix, "TrialTags"));
    //   delete data.Matrix["TrialTags"];

    //   let otherTags = TagsObject._parseTagsData(data.Matrix);
    //   console.log('received other tags', data.Matrix, this.otherTags);
    //   otherTags.forEach(e => {
    //     this.tags.push(e);
    //   })
    // }

    this.userData = BaseObject._toLowerCaseInitialProperty(BaseObject._createArrayWithObjects(data.UserData.User));
    console.log("tags and userdata", this.tags, this.userData);
    // this.checkUserTags();

    store.commit("auth/setUser", {
      userData: this.userData[0]
    });

    if (data.UserData.UserLanguage.LanguageTagId !== undefined) {
      store.commit("setUserLanguage", data.UserData.UserLanguage.LanguageTagId)
    }
  }

  /**
   * it checks if the request contains the Administrator Tag
   * and set the relevant flag in the store
   * @param {} data
   */
  // checkUserTags() {
  //   let currentAccountId = store.getters.getCurrentAccountId;

  //   console.log("checkUserTags tags", this.tags, currentAccountId);
  //   this.tags.forEach(e => {
  //     if (e.Description === "Administrator" && e.Selected === "yes" && e.AccountId == currentAccountId) {
  //     //  && currentUserGroup.userGroupId === e.UserGroupTagId) {
  //       store.commit("auth/setTokenType", 2);
  //     }
  //     // if (e.Description === "Temp_Admin" && e.Selected === "yes") {
  //     //   console.warn('temporary trial user');
  //     //   store.commit("auth/setTokenType", 3);
  //     // }
  //   });
  // }

  /**
   * it creates the getUserData payload
   */
  createGetUserDataRequest() {
    const requestObject = {
      RelationType: "User",
      Id: store.getters["auth/userName"],
      Types: {
        "User":"User"
      },
    };
    return requestObject;
  }

  static _baseObjectDefinition() {
    return {
      name: "",
      FirstName: "",
      SurName: "",
      email: "",
      PhoneNumber: "",
      ZipCode: "",
      Country: "",
      UserRegistrationCode: "",
      LicensePlate: ""
    };
  }

  static _objectDefinition() {
    return {
      userFirstname: "",
      userLastName: "",
      userEmail: "",
      vipCode: '',
      userTags: [],
      password: '',
      password2: ''
    };
  }
  static _createRegisterRequest(object) {
    let requestObject = {
      UserFirstName: object.userFirstname,
      UserLastName: object.userLastName,
      SubType: "1",
      UserTags: [],
      FrontEndType: "WEB"
    };
    const N = object.userTags.length;
    for (let e = 0; e < N; e++) {
      requestObject.UserTags[e] = object.userTags[e];
    }

    const json = JSON.stringfy(requestObject);

    return json;
  }

  static _createActivateUserObject(id, email, ps, token, type, partnerId) {

    const requestObject = {};
    if (partnerId !== undefined) {
      this.requestObject = {
        client_id: id,
        Email: email,
        Password: ps,
        Type: type,
        Token: token,
        PartnerId: Number(partnerId)
      }
    } else {
      this.requestObject = {
        client_id: id,
        Email: email,
        Password: ps,
        Type: type,
        Token: token
      }
    }
    return this.requestObject;
  }
  static _createRegisterRequestObject(object) {
    console.log('_createRegisterRequestObject', object);
    const requestObject = {};
    if (store.getters.getRedirectedFromPearlCalendar == true && store.getters.getSavePartnerId !== "") {
          this.requestObject = {
            client_id: "MoXA5aY6gNyahQ9SMntzJ3Adj8BLyhuDSgVW1ft9",
            Email: object.email,
            Password: object.password,
            Type: object.type,
            RegisteredFrom: "WEB",
            PartnerId: Number(store.getters.getSavePartnerId),
            GoTo: object.goTo,
          }
    } else {
      this.requestObject = {
        client_id: "MoXA5aY6gNyahQ9SMntzJ3Adj8BLyhuDSgVW1ft9",
        Email: object.email,
        Password: object.password,
        Type: object.type,
        RegisteredFrom: "WEB",
        GoTo: object.goTo,
      };
    }

    return this.requestObject;
  }

  /**
   * it creates an edit user request to use for
   * saveUserData
   * @param {an object instance} object
   */
  static _createEditRequestObject(object) {
    console.log("_createEditRequestObject", object);
    let req = {
      Tags: object.tags,
      FirstName: object.FirstName,
      LastName: object.LastName,
      Email: object.Email,
      PhoneNumber: object.PhoneNumber,
      PostalCode: object.PostalCode,
      Country: object.Country,
      LicensePlate: object.LicensePlate
    };
    // for (const [k, v] of Object.entries(object)) {
    //   if (k == "userTags") {
    //     console.log("_createEditRequestObject userTags", k, v);
    //     req["Tags"] = {};
    //     v.forEach((_tag, i) => {
    //       req["Tags"][i] = _tag;
    //     });
    //   } else {
    //     req[k] = v;
    //   }
    // }

    req.UserIndex = Number(req.UserIndex);
    req.dob = Number(req.dob);
    req.last_active_timestamp = Number(req.last_active_timestamp);
    req.UserId = object.name;

    // console.log("_createEditRequestObject out ", retObj);
    return req;
  }
}
